export default __webpack_public_path__ + "static/media/analytics-icon.425ab1a5.svg";